import { BaseError } from 'make-error-cause';

export class TimeoutError extends BaseError {
  public constructor(message: string) {
    super(message);
  }
}

export function timeoutPromise<T>(promise: Promise<T>, timeout: number): Promise<T> {
  return Promise.race([
    promise,
    new Promise<never>((resolve, reject) =>
      setTimeout(() => reject(new TimeoutError('Timeout has occurred')), timeout),
    ),
  ]);
}
